import gql from 'graphql-tag';

export const DELETE_PAGE_MUTATION = gql`
  mutation DeletePage($id: ID!) {
    deletePage(id: $id) {
      page {
        id
      }
    }
  }
`;
